import React from 'react'
import { connect } from 'react-redux';
import { routers } from '../../../Constants/routers';
import { updateSearchParameters } from '../../../Redux/SearchEngine/actions';
import { logout } from '../../../Redux/User/actions';
import { rawHeader } from './HeaderRaw';

let popularSearchKeywordInput, popularSearchKeywordList,  
categoriesInput, categoriesTagList, searchFilterOptions,
searchButton, megaMenuCategories;

const MainHeader = (props) => {
    const { isHome, categories = [], searchParameters, hideSearch } = props;

    const updateSearchParameters = (e) => {
       props.updateSearchParameters({ ...searchParameters, ...e })
    }

    window.logout = () => {
        props.logout();
    }

    window.help = () => {
        alert("Help page is coming soon...")
    }

    const addOrRemoveCategoy = () => {
        let ids = []
        const d = document.getElementsByClassName("categories-tag-list-item")
        let reads = "";
        d.forEach(el => {
            if(el.classList.contains("is-active")){
                ids.push(Number(el.getAttribute("category-id")))
                reads = `${reads}${el.innerHTML}, `
            }
        });
        updateSearchParameters({ categories: [...ids] });
        categoriesInput.value = reads
    }


    const init = () =>{
        // Searches Filter Options
        searchButton = document.getElementById("search-action-button");

        
        categoriesInput = document.getElementById("category-input-box");
        categoriesTagList = document.getElementById("categories-tag-list");
        megaMenuCategories = document.getElementById("explore-mega-menu-categories");
        
        popularSearchKeywordInput = document.getElementById("popular-search-keywords-input");
        popularSearchKeywordList = document.getElementById("popular-search-keywords");
       
        searchFilterOptions = document.getElementsByClassName("is-switch search-filter-option");
        
        searchFilterOptions && searchFilterOptions.forEach((el) => {
            const name = el.getAttribute("data-name");
            el.addEventListener("change", (e) => {
                updateSearchParameters({ [name]: e.target.checked })
            });
            if(searchParameters[name]) el.setAttribute("checked", true)
        });

        popularSearchKeywordInput && popularSearchKeywordInput.addEventListener("input", (e) => {
            const value = e.target.value;
            setRelatedKeywords(value)
            updateSearchParameters({ keyword: value });
        });
        
        categoriesInput && categoriesInput.addEventListener("input", (e) => {
            const value = e.target.value;
            setCategoriesInput(value)
            updateSearchParameters({ categoriesInput: value });
        });

        searchButton && searchButton.addEventListener("click", () => {
            window.location = routers.pages.search(searchParameters)
        })
        
        // Init values
        if(categoriesTagList) setCategoriesInput();

        if(popularSearchKeywordInput){
            popularSearchKeywordInput.value = searchParameters?.keyword||"";
            setRelatedKeywords();
        }

        if(window.location.pathname === "/search"){
            searchButton.style.display = "none";
        }
        
    }


    const setRelatedKeywords = (value="") => {
        if(!popularSearchKeywordInput) return;
        const LIST = ["malaria", "fever", "typhoid", "stomach pain"]
        LIST.map((search) => {
            const e = document.createElement("span");
            e.className = "tag";
            e.innerHTML = search;
            e.addEventListener("click", (e) => {
                 popularSearchKeywordInput.value = e.target.innerHTML;
                 updateSearchParameters({ keyword: e.target.innerHTML });
            });
            popularSearchKeywordList && popularSearchKeywordList.appendChild(e);
        });
    }


    const setCategoriesInput = (value="") => {
    if(!categoriesTagList){
        return;
    }
            categoriesTagList.innerHTML = "";
            let reads = "";
            const LIST = categories.filter(({ title = "", sector = "" }) => (title+sector).toLowerCase().includes(value.toLowerCase()));
            LIST.map((cat) => {
                const e = document.createElement("span");
                if((searchParameters.categories||[]).includes(cat.id)){
                    e.className = "categories-tag-list-item tag is-active";
                    reads = `${reads}${cat.title}, `
                }else{
                    e.className = "categories-tag-list-item tag";
                }
                e.setAttribute("category-id", cat.id)
                e.innerHTML = cat.title;
                e.addEventListener("click", (e) => {
                    if(e.target.classList.contains("is-active")){
                        e.target.classList.remove("is-active")
                    }else{
                        e.target.classList.add("is-active")
                    }
                    addOrRemoveCategoy()
                });
                categoriesTagList.appendChild(e);
            });

            if(megaMenuCategories){
                // categoriesInput.value = reads;
                LIST.slice(0,10).map((e) => {
                    // <a href="home-2.html" class="tag is-rounded">Trekking</a>
                    const i = document.createElement("a");
                    i.className = "tag is-rounded";
                    i.innerHTML = e.title;
                    i.setAttribute("href", routers.pages.search({ category: e.title }));
                    megaMenuCategories.appendChild(i)
                })

            }

    }

    React.useEffect(() => {
        init()
    }, [])

    return (
        <>
        {/* {searchParameters.categories.map(e => {return <span style={{ background: "red", padding: 10, marginRight: 5 }}>{e}</span>})} */}
        <div dangerouslySetInnerHTML={{ __html: rawHeader({ isHome, hideSearch }) }} />
        </>
    )
}


const mapStateToProps = ({ searchParameters, categories }) => {
	return { searchParameters, categories: categories?.allcategories||[] };
};

const mapDispatchToProps = (dispatch) => {
	return {
        updateSearchParameters: (e) => dispatch(updateSearchParameters(e)),
        logout: (e) => dispatch(logout(e)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainHeader);
